import { useEffect, useRef } from 'react';

const useMountedTracking = () => {
  const isMounted = useRef<boolean>(true);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
};

export default useMountedTracking;
